/* eslint-disable no-nested-ternary */
// Dependencies
import React, { useState } from 'react';
import { useParams } from 'react-router-dom';

// Components
import Template from '../../components/Template';
import FixedJobRequest from '../../components/JobRequest';

// Store
import user from '../../store/user';
import useStatusService from '../../hooks/useStatusService';
import useMaintenaceCompany from '../../hooks/useMaintenaceCompany';

// Hook
import useTermsAndConditions from '../../hooks/useTermsAndConditions';

function Terms() {
  const { newMaintenances } = useStatusService();
  const { newMaintenancesCompany } = useMaintenaceCompany();
  const { slug } = useParams();
  const { termPage, locale } = useTermsAndConditions(slug);
  const [userStore] = user();
  /* 4 -> is rol workshops */
  /* 3 -> is rol company */
  const [typeTemplate] = useState(userStore.token ? (userStore.rol === 4 ? 3 : 4) : 2);
  return (
    <Template
      type={typeTemplate}
      newMaintenances={
        userStore.token ? (userStore.rol === 4 ? newMaintenances : newMaintenancesCompany) : 0
      }
      component="terms"
      classNameContainer="terms"
      className="container_menu terms"
    >
      {userStore.rol === 3 ? <FixedJobRequest /> : ''}
      <div className="row">
        <div
          className="col description-term"
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{ __html: termPage[locale].body }}
        />
      </div>
    </Template>
  );
}

export default Terms;
